import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";

import FtueModal from "./FtueModal";
import { FtueModalProps } from "./types";

/**
 * Capability wrapper around {@link FtueModal}. Renders the modal only when the
 * `onboarding.ftueModal` capability is allowed for the current brand (e.g. hidden on SecretMate);
 * keeps FtueModal itself free of capability concerns.
 */
export default function CapabilityFtueModal(props: FtueModalProps) {
  return (
    <CapabilityGate capability={SubCapabilityKey.OnboardingFtueModal}>
      <FtueModal {...props} dataTestId="FtueModalCapabilityGate" />
    </CapabilityGate>
  );
}
